<template>
  <div class="container-fluid">
    <InitialQuestion
      :save-data="saveData"
      :next-question="nextQuestion"
      :disabled-criteria="disabledCriteria"
    >
      <template v-slot:form>
        <h5 class="regions__title">
          Selecciona las regiones en las que estarías dispuesto a estudiar.
        </h5>
        <hr>
        <div
          v-if="loading_map"
          class="spinner-border text-primary"
          role="status"
        >
          <span class="sr-only">Loading...</span>
        </div>
        <div
          v-else
          class="row"
        >
          <div
            class="col-sm-8"
            style="padding-right: 0px;"
          >
            <l-map
              ref="map"
              :zoom="zoom"
              :center="center"
              :options="mapOptions"
              :style="calculateHeight"
            >
              <l-tile-layer
                :url="url"
                :attribution="attribution"
              />
              <l-geo-json
                ref="myMap"
                :geojson="regions"
                :options="regionLayerOptions"
                :regions="selectedRegions"
              />
            </l-map>
          </div>
          <div class="col-sm-4">
            <div class="mb-2">
              Provincias:
            </div>
            <div class="regions__selector">
              <div
                v-for="(feature, index) in selectable_regions"
                :key="feature.properties.name"
              >
                <input
                  :id="index"
                  v-model="selectedRegions"
                  type="checkbox"
                  :value="{'name': feature.properties.name}"
                  @click="colorRegion(feature.properties.name)"
                >
                <label
                  class="regions__label"
                  :for="index"
                >{{ feature.properties.long_name | capitalize }}</label>
              </div>
            </div>
          </div>
        </div>
      </template>
    </InitialQuestion>
  </div>
</template>

<script>
/* global L */
// @ is an alias to /src
import { LMap, LTileLayer, LGeoJson } from 'vue2-leaflet';
import InitialQuestion from '@/components/InitialQuestion.vue';
import { studentsService } from '../../_services';
import CONFIG from '../../config';

export default {
    name: 'Regions',
    components: {
        LMap,
        LTileLayer,
        LGeoJson,
        InitialQuestion,
    },
    data() {
        return {
            zoom: this.calculateZoom(),
            center: L.latLng(18.8, -70.122158),
            url:
                'https://upload.wikimedia.org/wikipedia/commons/d/d2/Solid_white.png',
            attribution:
                '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            mapOptions: {
                zoomSnap: 0.5,
                zoomControl: false,
                scrollWheelZoom: false,
                dragging: false,
                doubleClickZoom: false,
                keyboard: false,
            },
            regionLayerOptions: {
                style: (feature) => {
                    if (feature.properties.selectable) {
                        return {
                            color: 'white',
                            weight: 1,
                            opacity: 1,
                            fillColor: this.color(feature.properties.name, 'style'),
                            fillOpacity: 1,
                        };
                    }
                    return {
                        color: 'white',
                        weight: 1,
                        opacity: 1,
                        fillColor: '#d6d6d6',
                        fillOpacity: 1,
                    };
                },
                onEachFeature: (feature, layer) => {
                    if (!feature.properties.selectable) {
                        return;
                    }
                    layer.on({
                        mouseover: (e) => {
                            e.target.setStyle({
                                fillColor: this.color(feature.properties.name, 'mouseover'),
                            });
                            e.target.bindTooltip(
                                feature.properties.long_name,
                                {
                                    permanent: false,
                                    direction: 'center',
                                },
                            )
                                .openTooltip();
                        },
                        mouseout: e => e.target.setStyle({
                            fillColor: this.color(feature.properties.name, 'mouseout'),
                        }),
                        click: (e) => {
                            this.toggle(feature.properties.name);
                            e.target.setStyle({
                                fillColor: this.color(feature.properties.name, 'click'),
                            });
                        },
                    });
                },
            },
            regions: {
                type: 'FeatureCollection',
                features: [],
            },
            selectable_regions: [],
            selectedRegions: [],
            country_name: 'republica_dominicana',
            // defaults with true to avoid errors
            loading_map: true,
        };
    },
    computed: {
        calculateHeight() {
            const widhtWindow = window.innerWidth;
            if (widhtWindow > CONFIG.responsive.minWidth) {
                return 'height: 600px;';
            }
            return 'height: 300px;';
        },
    },
    mounted() {
        this.$nextTick(function () {
            const studentData = this.$route.params.student_data;
            this.$store.commit('authentication/checkedRegion');
            if (studentData.regions.length !== 0) {
                this.$router.push({
                    name: 'areas',
                    params: {
                        student_data: studentData,
                    },
                });
            }
            this.getData();
            setTimeout(
                () => {
                    this.$refs.map.mapObject.invalidateSize();
                },
                3000,
            );
        });
    },
    methods: {

        calculateZoom() {
            const widhtWindow = window.innerWidth;
            if (widhtWindow > CONFIG.responsive.minWidth) {
                return 7.8;
            }
            return 7;
        },
        disabledCriteria() {
            return this.selectedRegions.length === 0;
        },
        async saveData() {
            studentsService.patchStudent(
                this.$store.getters['authentication/student_uuid'],
                { regions: this.selectedRegions },
            );
        },
        nextQuestion() {
            this.$store.commit('authentication/answeredRegion');
            this.$router.push({
                name: 'areas',
                params: { student_data: this.$route.params.student_data },
            });
        },
        getData() {
            this.loading_map = true;
            studentsService.country(this.country_name).then((response) => {
                this.regions = response.data.regions;
                this.selectable_regions = this.regions.filter(
                    region => region.properties.selectable,
                );
                this.loading_map = false;
            });
        },
        toggle(obj) {
            if (!this.selectedRegions.find(element => element.name === obj)) {
                this.selectedRegions.push({ name: obj });
            } else {
                this.selectedRegions.splice(
                    this.selectedRegions.findIndex(
                        element => element.name === obj,
                    ),
                    1,
                );
            }
        },
        color(regionName, method) {
            if (!this.selectedRegions.find(element => element.name === regionName)) {
                if (method === 'mouseover') {
                    return '#a2d1ff';
                }
                return '#e8e8e8';
            }
            return '#4a90e2';
        },

        colorRegion(regionName) {
            this.toggle(regionName);
            // NOTE: Assumes region exists
            const map = this.$refs.myMap.mapObject;
            let layerToColor;
            map.eachLayer((layer) => {
                if (layer.feature.properties.name === regionName) {
                    layerToColor = layer;
                }
            });
            layerToColor.setStyle({
                fillColor: this.color(regionName, 'region'),
            });
        },
    },
};
</script>

<style lang="scss">
@import "../../../node_modules/leaflet/dist/leaflet.css";
#app {
    overflow-x: hidden;
}

.leaflet-control {
    display: none !important;
}

.regions {
    &__title{
        text-align: center;
        max-width: 400px;
        margin: 0 auto;
    }
    &__selector {
        max-height: 550px;
        overflow-y: auto;
    }
    &__label {
        color: #4a4a4a;
        margin-left: 0.5rem;
        font-weight: 300;
    }
}

// <link rel="stylesheet" href="https://unpkg.com/leaflet@1.1.0/dist/leaflet.css" />
</style>
